import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import ErrorCom from "./Components/ErrorCom";
import NotAdmin236 from "./pages/NotAdmin236";
import { AuthContextProvider } from "./context/AuthContext";
import { WebAuthProvider } from "./context/WebAuthContext";
import AuthRouter from "./components/WebAuth/AuthRouter";
import Dashboard from "./pages/admin/Dashboard";
import Settings from "./pages/admin/Settings";
import EditTasks from "./pages/admin/EditTasks";
import AdminAdvertTasks from "./pages/admin/AdminAdvertTasks";
import Search from "./pages/admin/Search";
import Statistics from "./pages/admin/Statistics";
import AlphaDogs from "./pages/AlphaDogs";

import AdminStats from './pages/admin/AdminStats';
import AdminMiniPathPage from './pages/admin/AdminMiniPathPage';
import TrainingAccessManager from './pages/admin/TrainingAccessManager';
import CourseBuilder from './pages/admin/CourseBuilder';

import ClubLibrary from "./pages/Club";
import MasterClasses from "./pages/MasterClasses";
import LessonPage from "./pages/LessonPage";
import Training from "./pages/Training";
import CourseDetail from './pages/CourseDetail';
import CourseBlockDetail from './pages/CourseBlockDetail';

import KnowledgeBase from "./pages/KnowledgeBase";
import Meditations from "./pages/Meditations";
import Tehniki from "./pages/Tehniki";
import Guest from "./pages/Guest";
import AudioLessonsPage from "./pages/AudioLessonsPage";
import AudioLessonsList from "./pages/Meditations";
import MiniPathPage from "./pages/MiniPathPage";
import Miniputi from "./pages/Miniputi";
import CourseAudioPlayer from "./pages/CourseAudioPlayer";
import VerifyEmail from "./pages/VerifyEmail";
import ResetPassword from "./pages/ResetPassword";

// Компонент-обертка для проверки публичных маршрутов (ДОЛЖЕН БЫТЬ ВНУТРИ РОУТЕРА)
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const publicRoutes = ['/reset-password', '/verify-email'];
  
  // Если это публичный маршрут - показываем без AuthRouter
  if (publicRoutes.includes(location.pathname)) {
    return <>{children}</>;
  }
  
  // Иначе оборачиваем в AuthRouter
  return <AuthRouter>{children}</AuthRouter>;
};

// Создаем компонент-обертку для маршрутов
const AppRoutes = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <Home />
        </ProtectedRoute>
      ),
      errorElement: <ErrorCom />,
      children:[
        {
          path:"/",
          element: <AlphaDogs />,
        },
        {
          path:"/dashboardlogin",
          element: <NotAdmin236 />,
        },
        {
          path:"/club",
          element: <ClubLibrary />,
        },
        {
          path:"/master",
          element: <MasterClasses />,
        },
        {
          path:"/master-class/:id",
          element: <LessonPage />,
        },
        {
          path:"/training",
          element: <Training />,
        },
        {
          path:"/training/:id",
          element: <LessonPage />,
        },
        {
          path:"/masterClasses/:id",
          element: <LessonPage />,
        },
        {
          path:"/knowledge-base",
          element: <KnowledgeBase />,
        },
        {
          path:"/meditations",
          element: <Meditations />,
        },
        {
          path:"/Tehniki",
          element: <Tehniki />,
        },
        {
          path:"/guest",
          element: <Guest />,
        },
        {
          path:"/AudioLessonsPage/:id",
          element: <AudioLessonsPage />,
        },
        {
          path:"/audio-lessons",
          element: <AudioLessonsList />,
        },
        {
          path:"/miniputi",
          element: <Miniputi />,
        },
        {
          path:"/MiniPath/:id",
          element: <MiniPathPage />,
        },
        {
          path:"/MiniPath",
          element: <MiniPathPage />,
        },
        {
          path:"/course/:id",
          element: <CourseDetail />,
        },
        {
          path:"/course/:id/block/:blockId",
          element: <CourseBlockDetail />,
        },
        {
          path:"/course-audio/:url",
          element: <CourseAudioPlayer />,
        },
      ]
    },
    {
      path: "/dashboardAdx",
      element: (
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      ),
      errorElement: <ErrorCom />,
      children:[
        {
          path:"/dashboardAdx/settings",
          element: <Settings />,
        },
        {
          path:"/dashboardAdx/managetasks",
          element: <EditTasks />,
        },
        {
          path:"/dashboardAdx/promo",
          element: <AdminAdvertTasks />,
        },
        {
          path:"/dashboardAdx/search",
          element: <Search />,
        },
        {
          path:"/dashboardAdx/stats",
          element: <Statistics />,
        },
        {
          path:"/dashboardAdx/utm",
          element: <AdminStats />,
        },
        {
          path:"/dashboardAdx/Mini",
          element: <AdminMiniPathPage />,
        },
        {
          path:"/dashboardAdx/training-access",
          element: <TrainingAccessManager />,
        },
        {
          path:"/dashboardAdx/courses",
          element: <CourseBuilder />,
        },
      ]
    },
    {
      path: "/verify-email",
      element: <VerifyEmail />,
    },
    {
      path: "/reset-password",
      element: <ResetPassword />,
    }
  ]);

  return <RouterProvider router={router} />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthContextProvider>
    <WebAuthProvider>
      <React.StrictMode>
        <AppRoutes />
      </React.StrictMode>
    </WebAuthProvider>
  </AuthContextProvider>
);